import { render } from "./Books.vue?vue&type=template&id=5ed67a28&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"

import "./Books.vue?vue&type=style&index=0&id=5ed67a28&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed67a28"]])

export default __exports__